/* EarthBased vendor pincode checker + purchase gate - 4 Sep 2026 (v10)
   Replaces the Zippy Zipcode Validator app.

   ============================================================================
   WHY v10 EXISTS
   ============================================================================
   Owner report, 4 Sep 2026: "on some devices the pincode checker shows" on
   products that are not Millie's. Reproduced: put a Millie's item in the cart,
   open ANY other product page, and the Millie's "fresh, chilled product" notice
   plus pincode box was drawn under that product's BUY NOW. The cart gate was
   correct to be active (a Millie's item still has to be pincode-checked before
   checkout) but it was building its box on the wrong page. v9's anchor() used
   the product-page mount points whenever they existed, without asking whether
   the product on screen was the restricted one.

   v10 changes two things:
     1. anchor() uses the product-page mount points ONLY when the product on
        screen is itself restricted (productGated). A cart-only gate on an
        unrestricted product page now builds nothing there, guards the checkout
        controls only, and sends the shopper to the cart page - where the box
        does build, above BUY NOW. That path already existed (redirectOnly).
     2. A boot guard. snippets/rapid-search-settings.liquid was ALSO loading this
        file and an older window.EB_PINCODE config (no cartVendors) on every
        product page, so the script ran twice and shipped the pincode JSON twice.
        That duplicate loader has been removed from the snippet, and this guard
        makes a second run a no-op if it ever comes back.

   ============================================================================
   WHY v9 EXISTS - READ THIS FIRST
   ============================================================================
   v8 of this file was correct and it still did nothing at all, because NOTHING
   IN THE THEME EVER LOADED IT. There was no <script> tag for it and no
   window.EB_PINCODE config anywhere: not in layout/theme.liquid, not in
   sections/main-product.liquid, not in templates/product.json. The file sat in
   assets/ as an orphan. The only pincode UI actually on the live product page
   was the OLD Zippy Zipcode Validator app block, which shows a message and does
   not gate the buy buttons at all.

   That is how order #EBOR7822 (2 Sep 2026) shipped two Millie's items to
   Ghaziabad 201002, which is not in the serviceable list.

   v9 therefore does three things:
     1. It is now actually loaded. snippets/eb-pincode.liquid renders the config
        and the script tag from <head> in layout/theme.liquid, on EVERY page.
     2. It gates the CART as well as the product page. The product page was the
        only gated surface; a shopper could add a restricted item from a
        collection card or quick view, open the cart or the cart drawer, and
        check out without ever seeing a pincode box.
     3. The Zippy app block was removed from templates/product.json so there is
        exactly one pincode checker on the page.

   IF THE GATE EVER LOOKS DEAD AGAIN, CHECK THIS FIRST, IN THIS ORDER:
     window.EB_PINCODE            -> undefined means the snippet is not rendering
     window.EB_PINCODE.rules      -> {} means the shop metafield is missing/invalid
     document.querySelector('.eb-pincode')   -> null means the box did not build
     window.EB_PINCODE_LOCKED     -> should be true before a serviceable pincode

   ============================================================================
   HOW IT WORKS
   ============================================================================
   Only vendors WITH delivery restrictions are listed in the shop metafield
   custom.vendor_pincodes. If neither the product being viewed nor anything in
   the cart belongs to a listed vendor, this script does NOTHING AT ALL - no
   notice, no widget, no gating, buttons untouched, and window.EB_PINCODE_LOCKED
   is never set.

   When a restricted vendor IS involved:
     - on THAT vendor's product page and on the cart page, an always-visible
       notice explains the limited delivery area
     - Add To Cart (restricted product page only), BUY NOW and CHECKOUT look
       completely normal but are not usable; clicking any of them smooth-scrolls
       to the pincode box and focuses it - or, on a page with no box, goes to
       the cart page
     - once a serviceable pincode is entered the block is removed entirely
     - the confirmed pincode is remembered (localStorage) and re-validated on
       every page against whatever restricted vendors are in play, so customers
       are not asked repeatedly

   MIXED CARTS: if the cart holds two restricted vendors, the pincode must be
   serviceable for BOTH. That is deliberate - one order, one shipping address.

   ============================================================================
   THIS IS FRONT-END GATING - IT IS NOT ENFORCEMENT
   ============================================================================
   It stops honest customers, not determined ones, and it cannot see the address
   actually typed at checkout: a shopper can clear a serviceable pincode here and
   then ship somewhere else. Real enforcement has to happen in Shiprocket's
   checkout serviceability settings or in a Shopify cart/checkout validation
   function. Until one of those exists, keep watching order pincodes.

   ============================================================================
   CARE POINTS - READ BEFORE EDITING
   ============================================================================
   - The buttons are deliberately NOT greyed out and NOT pointer-events:none.
     Blocking is done purely by a capture-phase click listener registered at
     parse time, which is why the script tag must NOT use defer or async -
     it has to be registered before Shiprocket's button script.
   - Never remove or replace Shiprocket's button element.
   - BUY_CONTROLS lists buy CONTROLS ONLY, never a form or a container.
     .closest() walks UP the tree, so a container selector would match every
     click inside the buy box (quantity steppers, variant swatches, accordions)
     and make the product page feel broken. That was the v6 bug.
   - The sr-* entries are Shiprocket's headless BUY NOW button and they live in
     CHECKOUT_CONTROLS, because on the cart page Shiprocket REPLACES the theme's
     [name="checkout"] button with its own. If Shiprocket changes its markup
     again, THAT is the line to update - verify on BOTH a product page and the
     cart page with
       document.querySelector('button.sr-headless-checkout')
     and confirm a locked page ignores a BUY NOW click on each. That was the v8
     bug, and then again the first cut of v9.
   - Regexes here use SINGLE backslashes. Doubling \D broke the input sanitiser
     and rejected valid pincodes typed with a space or a dash. That was the v7
     bug. Do not re-escape when copying this file around.

   ============================================================================
   window.EB_PINCODE_LOCKED - DO NOT REMOVE
   ============================================================================
   Set true while the gate is blocking, false once unlocked. eb-cart-fix.js
   reads it. Without it, the cart safety net sees the blocked click as a failed
   add and adds the product anyway, defeating the gate and showing a false
   "Added to cart" toast. The scripts cannot coordinate through the DOM event,
   because eb-cart-fix.js registers its listener first and runs before this
   script's stopImmediatePropagation() can take effect.

   ============================================================================
   EDIT COVERAGE AND WORDING
   ============================================================================
   Shopify admin > Settings > Custom data > Shop > Vendor pincode rules.
     "note"     - the always-visible notice on the product page
     "message"  - extra line shown when a pincode is NOT serviceable
     "pincodes" - exact serviceable pincodes
     "prefixes" - optional, matches any pincode starting with these digits
   Vendor names must match Shopify's Vendor field EXACTLY, curly apostrophes and
   all (Millie's is stored with U+2019, not a straight quote). */
(function(){
  'use strict';

  /* v10 boot guard - see header. A second <script> tag for this file is a no-op. */
  if(window.EB_PINCODE_BOOTED) return;
  window.EB_PINCODE_BOOTED = true;

  var cfg = window.EB_PINCODE;
  if(!cfg || !cfg.rules) return;

  /* Which restricted vendors are in play on this page?
     - the product being viewed (product template only)
     - every vendor currently in the cart (any template) */
  var names = [];
  function addVendor(v){
    if(!v) return;
    if(!Object.prototype.hasOwnProperty.call(cfg.rules, v)) return; /* unrestricted */
    if(names.indexOf(v) === -1) names.push(v);
  }
  addVendor(cfg.vendor);
  var cartVendors = cfg.cartVendors || [];
  for(var i = 0; i < cartVendors.length; i++){ addVendor(cartVendors[i]); }

  if(!names.length) return; /* nothing restricted here - do nothing at all */

  var rules = [];
  for(var n = 0; n < names.length; n++){ rules.push(cfg.rules[names[n]]); }

  /* Is this gate about the product on screen, or only about the cart?
     A cart-only gate must never block Add To Cart on an unrestricted product -
     it only guards the checkout buttons - and (v10) must never draw its box on
     an unrestricted product page. */
  var productGated = !!(cfg.vendor && Object.prototype.hasOwnProperty.call(cfg.rules, cfg.vendor));

  var GREEN = '#4a8e5a';
  var RED   = '#c0392b';
  var INK   = '#253d4e';
  var AMBER_BG = '#fff8e6';
  var AMBER_BD = '#f0d9a0';
  var STORE_KEY = 'eb_pincode';
  var WATCHDOG_MS = 2500;
  var CART_URL = cfg.cartUrl || '/cart';

  var outEl = null;
  var inputEl = null;

  function setLocked(v){ window.EB_PINCODE_LOCKED = v; }
  setLocked(true); /* locked from the moment this script parses */
  function isLocked(){ return window.EB_PINCODE_LOCKED === true; }

  function ruleServes(rule, pin){
    var p = rule.prefixes || [];
    for(var i = 0; i < p.length; i++){ if(pin.indexOf(String(p[i])) === 0) return true; }
    var l = rule.pincodes || [];
    for(var j = 0; j < l.length; j++){ if(String(l[j]) === pin) return true; }
    return false;
  }

  /* EVERY restricted vendor in play must serve the pincode. One order, one address. */
  function serviceable(pin){
    for(var i = 0; i < rules.length; i++){ if(!ruleServes(rules[i], pin)) return false; }
    return true;
  }

  function blockedVendorsFor(pin){
    var out = [];
    for(var i = 0; i < rules.length; i++){ if(!ruleServes(rules[i], pin)) out.push(names[i]); }
    return out;
  }

  function noticeText(){
    if(rules.length === 1){
      return rules[0].note || rules[0].message ||
        'This product delivers only to selected pincodes.';
    }
    return 'Your cart has items from ' + names.join(' and ') +
      ', which deliver only to selected pincodes. Enter your pincode to continue, ' +
      'or place separate orders.';
  }

  /* ------------------------------------------------------------------
     BUY CONTROLS - buy CONTROLS ONLY, never a form or a wrapper.
     ------------------------------------------------------------------ */

  /* Add-to-cart only. Product page. */
  var ADD_CONTROLS = '.add-to-cart-button, button[name="add"], input[name="add"],' +
    ' [data-shopify="payment-button"], .shopify-payment-button';

  /* Anything that takes the shopper to checkout, on ANY template.

     THE SHIPROCKET BUTTON BELONGS IN THIS LIST, NOT IN ADD_CONTROLS. On the CART
     page Shiprocket REPLACES the theme's own checkout button: sections/main-cart.liquid
     renders <button name="checkout" class="checkout-page-cart">, but by the time
     shopify.js has run the only thing in .cart-totals .buttons is
     <button name="sr-headless-button" class="sr-headless-checkout">BUY NOW</button>
     and there is no [name="checkout"] on the page at all. Verified on the cart page,
     3 Sep 2026. When these selectors lived in ADD_CONTROLS the cart gate matched
     nothing and BUY NOW went straight to checkout - the same class of bug as v8,
     one page over. */
  var CHECKOUT_CONTROLS = 'button[name="checkout"], input[name="checkout"],' +
    ' .checkout-page-cart, .go-to-checkout button, .cart-dynamic-checkout-buttons button,' +
    ' .sr-headless-checkout, [name="sr-headless-button"], [class*="sr-headless"],' +
    ' [class*="sr-checkout"], [id*="sr-checkout"], [class*="shiprocket-headless"],' +
    ' [class*="fastrr"], [id*="fastrr"], [class*="buy-now"], [id*="buy-now"], [class*="buynow"]';

  var BUY_CONTROLS = productGated
    ? (ADD_CONTROLS + ', ' + CHECKOUT_CONTROLS)
    : CHECKOUT_CONTROLS;

  var redirectOnly = false; /* set when there is no box on this page to point at */

  function nudge(){
    var box = document.querySelector('.eb-pincode');

    /* No box on this page (e.g. a collection page or an unrestricted product page
       with a restricted item sitting in the cart). Send the shopper to the cart,
       where the box exists. */
    if(!box){
      if(redirectOnly){ window.location.href = CART_URL; }
      return;
    }

    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if(inputEl){ setTimeout(function(){ try { inputEl.focus(); } catch(e){} }, 350); }
    if(outEl){
      outEl.style.color = RED;
      outEl.textContent = 'Please check your pincode first.';
    }
    var panel = box.querySelector('.eb-pincode-panel');
    if(panel){
      panel.style.transition = 'box-shadow .25s ease';
      panel.style.boxShadow = '0 0 0 3px rgba(192,57,43,.18)';
      setTimeout(function(){ panel.style.boxShadow = ''; }, 1100);
    }
  }

  function blocker(e){
    if(!isLocked()) return;
    var t = e.target;
    if(!t || !t.closest) return;
    if(t.closest('.eb-pincode')) return;
    var hit = t.closest(BUY_CONTROLS);
    if(!hit) return;
    e.preventDefault();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    nudge();
  }
  document.addEventListener('click', blocker, true);

  function unlock(pin){
    setLocked(false);
    document.removeEventListener('click', blocker, true);
    if(pin){ try { localStorage.setItem(STORE_KEY, pin); } catch(err){} }
  }

  function relock(){
    if(!isLocked()){
      setLocked(true);
      document.addEventListener('click', blocker, true);
    } else {
      setLocked(true);
    }
  }

  /* Where the box goes, in order of preference:
       1. #eb-pincode-mount            - an explicit mount point, if a theme file
                                         ever renders one. Nothing does today.
       2. after .product-custom-liquid - PRODUCT PAGE, ONLY when the product on
                                         screen is itself restricted (v10). This is
                                         the delivery-date custom-liquid block in
                                         templates/product.json; the box lands
                                         directly under the buy box.
       3. appended to form.product-buy - restricted-product-page fallback (v10:
                                         same productGated condition).
       4. before .cart-totals .buttons - CART PAGE, directly above the checkout
                                         button (sections/main-cart.liquid). Found
                                         by selector on purpose, so the cart section
                                         itself needs no edit and no theme update
                                         can silently drop the mount point.
     Returns null when this page has nowhere sensible to put it - a collection
     page, or an UNRESTRICTED product page, with the only restricted item sitting
     in the cart. The watchdog then sets redirectOnly and a checkout click goes to
     the cart page. */
  function anchor(){
    var mount = document.getElementById('eb-pincode-mount');
    if(mount) return { el: mount, mode: 'in' };
    if(productGated){
      var host = document.querySelector('.product-custom-liquid');
      if(host && host.parentNode) return { el: host, mode: 'after' };
      var form = document.querySelector('form.product-buy');
      if(form) return { el: form, mode: 'in' };
    }
    var cartButtons = document.querySelector('.cart-totals .buttons');
    if(cartButtons && cartButtons.parentNode) return { el: cartButtons, mode: 'before' };
    return null;
  }

  function build(){
    if(document.querySelector('.eb-pincode')) return true;
    var at = anchor();
    if(!at){
      /* v10: nowhere to build on this page. If the shopper already confirmed a
         pincode that serves every restricted vendor in play, honour it here too -
         otherwise every unrelated product page would bounce them to the cart.
         Failing that, send a checkout click straight to the cart rather than
         swallowing it silently for the 2.5s watchdog window. */
      var savedPin = null;
      try { savedPin = localStorage.getItem(STORE_KEY); } catch(err){}
      if(savedPin && /^[1-9][0-9]{5}$/.test(savedPin) && serviceable(savedPin)){
        unlock(null);
        return false;
      }
      if(!productGated){ redirectOnly = true; }
      return false;
    }

    var box = document.createElement('div');
    box.className = 'eb-pincode';
    box.style.cssText = 'margin:14px 0;font-size:14px;color:' + INK;

    var notice = document.createElement('div');
    notice.className = 'eb-pincode-note';
    notice.style.cssText = 'display:flex;gap:8px;align-items:flex-start;padding:10px 12px;margin-bottom:10px;background:' + AMBER_BG + ';border:1px solid ' + AMBER_BD + ';border-radius:8px;font-size:13px;line-height:1.45';
    var marker = document.createElement('span');
    marker.textContent = '📍';
    marker.style.cssText = 'flex:0 0 auto;line-height:1.3;margin-right:8px';
    var noteText = document.createElement('span');
    noteText.textContent = noticeText();
    notice.appendChild(marker); notice.appendChild(noteText);

    var panel = document.createElement('div');
    panel.className = 'eb-pincode-panel';
    panel.style.cssText = 'padding:12px 14px;border:1px solid #d8f1e5;border-radius:10px;background:#fff';

    var label = document.createElement('label');
    label.textContent = 'Enter your pincode to continue';
    label.style.cssText = 'display:block;font-weight:600;margin-bottom:8px;font-size:13px';

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;align-items:center';

    var input = document.createElement('input');
    input.type = 'tel';
    input.inputMode = 'numeric';
    input.maxLength = 6;
    input.placeholder = '6-digit pincode';
    input.setAttribute('aria-label', 'Delivery pincode');
    input.style.cssText = 'flex:1 1 auto;min-width:0;margin-right:8px;padding:9px 12px;border:1px solid #d8f1e5;border-radius:6px;font-size:14px;color:' + INK;
    inputEl = input;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Check';
    btn.style.cssText = 'flex:0 0 auto;padding:9px 18px;border:0;border-radius:6px;background:' + GREEN + ';color:#fff;font-size:14px;cursor:pointer';

    var out = document.createElement('div');
    out.setAttribute('role', 'status');
    out.style.cssText = 'margin-top:8px;font-size:13px;line-height:1.45;min-height:18px';
    outEl = out;

    function check(silent){
      /* SINGLE backslash. This must read as "any non-digit". See the v7 note. */
      var v = (input.value || '').replace(/\D/g, '');
      if(!/^[1-9][0-9]{5}$/.test(v)){
        if(!silent){ out.style.color = RED; out.textContent = 'Please enter a valid 6-digit Indian pincode.'; }
        relock();
        return;
      }
      if(serviceable(v)){
        out.style.color = GREEN;
        out.textContent = '✓ Delivers to ' + v + '. You can place your order.';
        unlock(v);
      } else {
        var blocked = blockedVendorsFor(v);
        var extra = '';
        for(var i = 0; i < names.length; i++){
          if(blocked.indexOf(names[i]) !== -1 && rules[i].message){ extra += ' ' + rules[i].message; }
        }
        out.style.color = RED;
        out.textContent = '✗ Sorry, we do not deliver ' +
          (blocked.length === names.length ? 'this order' : blocked.join(' and ')) +
          ' to ' + v + ' yet.' + extra;
        relock();
      }
    }

    btn.addEventListener('click', function(){ check(false); });
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); check(false); } });

    row.appendChild(input); row.appendChild(btn);
    panel.appendChild(label); panel.appendChild(row); panel.appendChild(out);
    box.appendChild(notice); box.appendChild(panel);

    if(at.mode === 'after'){ at.el.parentNode.insertBefore(box, at.el.nextSibling); }
    else if(at.mode === 'before'){ at.el.parentNode.insertBefore(box, at.el); }
    else { at.el.appendChild(box); }

    var saved = null;
    try { saved = localStorage.getItem(STORE_KEY); } catch(err){}
    if(saved){ input.value = saved; check(true); }
    return true;
  }

  /* WATCHDOG - fail open on a restricted product page, redirect everywhere else.

     If the box is not on the page a short while after load, the gate has no way
     to tell the shopper what to do.
       - Restricted product page: holding the buy buttons hostage with no visible
         reason just looks broken, so release. This is nudging, not enforcement.
       - Anywhere else (cart drawer, unrestricted product page): do NOT release,
         because the cart page a click away DOES have a box. Keep guarding
         checkout only and send the shopper there. */
  function watchdog(){
    setTimeout(function(){
      if(document.querySelector('.eb-pincode')) return;
      if(productGated){ unlock(null); return; }
      redirectOnly = true;
    }, WATCHDOG_MS);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ build(); watchdog(); });
  } else { build(); watchdog(); }
})();
